import { render, staticRenderFns } from "./MenuFooterEn.vue?vue&type=template&id=86d4dc26&"
import script from "./MenuFooterEn.vue?vue&type=script&lang=js&"
export * from "./MenuFooterEn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports